import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../../../components/Modal";
import Loading from "../../../../../components/Loaders/Loading";
import { useAccess } from "../../../../../utils/hooks/access";
import VersionsTable from "./VersionsTable";
import Compare from "./Compare";
import { useTimeOffPlanVersions } from "./useTimeOffPlanVersions";

// Row action "Versions": a plan's versions (Discard on the pending one) and a comparison of two.
function VersionsModal({ isOpen, close, plan, onDiscarded }) {
    const { t } = useTranslation();
    const { hasAccess: canEdit } = useAccess("settings.payPolicies.timeOff.canEdit");
    const { versions, loading, openDiscardModal, discardModal } = useTimeOffPlanVersions(plan?.id, onDiscarded);

    return (
        <Modal
            isOpen={isOpen}
            toggle={close}
            size="xl"
            centered
            scrollable
            title={
                <div className="d-flex align-items-center justify-content-between">
                    <span className="text-truncate">
                        {t("time-off-plan-versions")}
                        {plan?.code ? ` · ${plan.code}` : ""}
                    </span>
                    <FontAwesomeIcon className="cursor-pointer ml-3" icon={faXmark} onClick={close} />
                </div>
            }
        >
            {loading && versions.length === 0 ? (
                <div className="d-flex justify-content-center py-5">
                    <Loading />
                </div>
            ) : versions.length === 0 ? (
                <p className="text-muted small mb-0">{t("no-data")}</p>
            ) : (
                <>
                    <VersionsTable
                        versions={versions}
                        onDiscard={canEdit ? openDiscardModal : undefined}
                    />

                    <h5 className="mt-4 mb-2">{t("time-off-plan-compare-versions")}</h5>
                    <Compare versions={versions} />
                </>
            )}

            {discardModal}
        </Modal>
    );
}

export default VersionsModal;
